import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['typeSelect', 'subcategorySelect', 'subcategoryContainer']

  connect() {
    this.subcategoriesData = JSON.parse(document.getElementById('subcategories-data')?.textContent || '{}')
  }

  updateSubcategories() {
    const selectedType = this.typeSelectTarget.value
    const subcategories = this.subcategoriesData[selectedType] || []

    const select = this.subcategorySelectTarget
    const currentValue = select.value

    // Clear existing options except the placeholder
    select.innerHTML = '<option value="">Select subcategory...</option>'

    // Add new options
    subcategories.forEach((subcat) => {
      const option = document.createElement('option')
      option.value = subcat
      option.textContent = subcat.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase())
      if (subcat === currentValue) {
        option.selected = true
      }
      select.appendChild(option)
    })
  }
}
